import { useState } from "react";
import { Reveal } from "../components/common/Reveal";
import { openRoles } from "../data/siteData";

export default function CareersPage() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    event.currentTarget.reset();
  };

  return (
    <div data-testid="careers-page" className="page-shell page-offset">
      <Reveal>
        <section data-testid="careers-intro-section" className="section-block">
          <div className="container-shell two-column">
            <div>
              <p data-testid="careers-eyebrow" className="eyebrow">Careers</p>
              <h1 data-testid="careers-heading" className="section-title">Built on skilled trades, long-term careers, and disciplined workmanship.</h1>
            </div>
            <p data-testid="careers-description" className="section-paragraph">
              Wayne Iron Works develops long-standing teams around safety, accountability, and craft. We hire people who respect engineered detail and take pride in delivering structural work the right way.
            </p>
          </div>
        </section>
      </Reveal>

      <Reveal>
        <section data-testid="careers-roles-section" className="section-block muted-bg">
          <div className="container-shell">
            <h2 data-testid="careers-roles-heading" className="section-title">Open Roles</h2>
            <div className="roles-grid">
              {openRoles.map((role) => (
                <article key={role} data-testid={`careers-role-${role.toLowerCase().replace(/\s+/g, "-")}`} className="role-card">
                  <h3 data-testid={`careers-role-title-${role.toLowerCase().replace(/\s+/g, "-")}`}>{role}</h3>
                  <p data-testid={`careers-role-description-${role.toLowerCase().replace(/\s+/g, "-")}`}>
                    Full-time opportunity focused on precision, safety, and execution excellence.
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      <section data-testid="careers-application-section" className="section-block">
        <div className="container-shell form-container">
          <h2 data-testid="careers-application-heading" className="section-title">Apply to Join Our Team</h2>
          <form data-testid="careers-application-form" className="form-grid" onSubmit={handleSubmit}>
            <input data-testid="careers-name-input" name="name" required type="text" placeholder="Full Name" className="text-input" />
            <input data-testid="careers-email-input" name="email" required type="email" placeholder="Email Address" className="text-input" />
            <input data-testid="careers-phone-input" name="phone" required type="tel" placeholder="Phone Number" className="text-input" />
            <input data-testid="careers-position-input" name="position" required type="text" placeholder="Role of Interest" className="text-input" />
            <textarea data-testid="careers-experience-input" name="experience" required rows="4" placeholder="Briefly describe your experience" className="text-input textarea" />
            <button data-testid="careers-submit-button" type="submit" className="primary-btn">
              Submit Application
            </button>
          </form>
          {submitted && (
            <div data-testid="careers-success-message" className="success-note">
              Thank you. Your application has been received. Our team will review and contact you.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
